import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { bookingModeSelector } from 'helper/filter';
import { EBookingMode } from 'types';

/**
 * Redirects to the appropriate offers page based on booking mode (SEM -> widget offers, EPILO -> lister offers).
 */
export default function BookingsRedirect() {
  const navigate = useNavigate();
  const bookingMode = bookingModeSelector();

  useEffect(() => {
    if (bookingMode === EBookingMode.SEM) {
      navigate('/offers/widget', { replace: true });
    } else if (bookingMode === EBookingMode.EPILO) {
      navigate('/offers/lister', { replace: true });
    }
  }, [bookingMode, navigate]);

  // Show loading spinner while redirecting
  return (
    <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
      <CircularProgress />
    </Box>
  );
}
